import {ChangeEvent, useState} from "react";
import {CheckBoxChangeEvent} from "../../../components/CheckBox";
import { useParams } from "react-router-dom";

export const useEventForm = (handleChange:  (event: ChangeEvent<HTMLInputElement>) => void, customHandleImageChange?: (file: File) => void, customHandlePdfChange?: (file: File) => void) => {
    const [imagePath, setImagePath] = useState<string | null>(null);
    const [logoIsPNG, setLogoIsPNG] = useState<boolean>(true);

    const { id } = useParams<{ id: string }>();
    const handleImageChange = async (e: ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) return;

        const file = e.target.files[0];
        if (file.type === "image/png") {
            setLogoIsPNG(true);
            const objectUrl = URL.createObjectURL(file); // Cria URL para preview
            setImagePath(objectUrl);
            customHandleImageChange?.(file);
            handleChange({
                target: {
                    name: 'logo.signedFileUrl',
                    value: file.name,
                }
            } as any);
        } else {
            setLogoIsPNG(false);
            setImagePath(null);
        }
    };


    const handlePdfChange = async (e: ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) return;
        const file = e.target.files[0];
        customHandlePdfChange?.(file);
        handleChange({
            target: {
                name: 'mapPdf.signedFileUrl',
                value: file.name,
            }
        } as any);
    };

    const handleCheckBoxChange = (fieldName: string) => (event: CheckBoxChangeEvent) => {
        const fakeEvent = {
            target: {
                name: fieldName,
                value: event.checked,
            }
        };
        handleChange(fakeEvent as any);
    };
    return {
        handleImageChange, imagePath, logoIsPNG, handleCheckBoxChange,
        handlePdfChange
    }
}